import { useEffect, useState } from "react";
import { motion, useScroll } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { COMPANY } from "../data";

const LINKS = [
  { label: "Über uns", href: "#ueber-uns" },
  { label: "Leistungen", href: "#leistungen" },
  { label: "Referenzen", href: "#referenzen" },
  { label: "Kontakt", href: "#kontakt" },
];

export const Navbar = () => {
  const { scrollYProgress } = useScroll();
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const onHome = pathname === "/";

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    fn();
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const solid = scrolled || !onHome;

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${solid ? "bg-white/95 backdrop-blur shadow-sm" : "bg-transparent"}`} data-testid="main-navbar">
      <motion.div
        className="absolute top-0 left-0 right-0 h-[3px] bg-[#2A5C2A] origin-left"
        style={{ scaleX: scrollYProgress }}
        data-testid="scroll-progress-bar"
      />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between h-16 sm:h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo">
          <svg width="40" height="26" viewBox="0 0 150 90" fill="none">
            <path d="M12 14 H58 L12 76 H58" stroke={solid ? "#2A5C2A" : "#fff"} strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M76 76 V14 L104 52 L132 14 V76" stroke={solid ? "#2A5C2A" : "#fff"} strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <div className="leading-tight">
            <span className={`font-heading font-bold text-base sm:text-lg ${solid ? "text-[#1A3C1A]" : "text-white"}`}>Zimmerei Müller</span>
            <span className={`hidden sm:block font-condensed text-xs tracking-[0.25em] ${solid ? "text-[#666666]" : "text-white/80"}`}>MEHR ALS DÄCHER</span>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={onHome ? l.href : `/${l.href}`}
              className={`nav-link font-condensed text-base tracking-[0.15em] uppercase ${solid ? "text-[#2A2A2A]" : "text-white"}`}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s|ü/g, (m) => (m === "ü" ? "ue" : "-"))}`}
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href={`tel:${COMPANY.phoneLink}`}
          className="btn-green flex items-center gap-2 rounded-full px-4 sm:px-5 py-2 text-sm font-semibold border border-[#2A5C2A]"
          data-testid="navbar-phone-cta"
        >
          <Phone size={15} /> {COMPANY.phone}
        </a>
      </div>
    </header>
  );
};
